import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import InputAddressPanel from '../InputAddressPanel/InputAddressPanel';
import { useTranslation } from 'react-i18next';
import useLogoUploader from '../../BasketPage/Hooks/Logo/useLogoUploader';
import { OverlayTrigger, Popover } from "react-bootstrap";
import useGetLogo from '../../BasketPage/Hooks/Logo/useGetLogo';
import LoadingSpinner from '../../Components/LoadingSpinner';

const CustomerDataCard = ({ address }) => {
  const { handleGetLogo, handleDeleteLogo } = useGetLogo()
  const { t } = useTranslation()
  const [isLoadingLogo, setIsLoadingLogo] = useState(false)
  const [handlingAddress, setHandlingAddress] = useState({ name: address.name, street: address.street, houseNum: address.houseNum, localNum: address.localNum, zipCode: address.zipCode, city: address.city, email: address.email, phone: address.phone })
  const [isChangeAddressVisible, setisChangeAddressVisible] = useState(false)
  const [initialLogoUrl, setInitialLogoUrl] = useState('/Icons/uploadImg.svg')
  const [logoUploaderProps, setLogoUploaderProps] = useState(null)
  const [deleteLogoTrigger, setDeleteLogoTrigger] = useState(false)

  useEffect(() => {
    handleLoadLogo()
  }, [])

  const handleLoadLogo = async () => {
    setIsLoadingLogo(true)
    const logoSrc = await handleGetLogo()
    const urlToUse = logoSrc || '/Icons/uploadImg.svg'
    setInitialLogoUrl(urlToUse)
    setLogoUploaderProps({
      defaultIconUrl: urlToUse
    })
    setIsLoadingLogo(false)
  }

  const handleEditAddress = (e) => {
    const { name, value } = e.target
    setHandlingAddress({
      ...handlingAddress,
      [name]: value
    })
  }
  const handleCancelButtonClick = () => {
    setHandlingAddress({ name: address.name, street: address.street, houseNum: address.houseNum, localNum: address.localNum, zipCode: address.zipCode, city: address.city, email: address.email, phone: address.phone })
    setisChangeAddressVisible(false)
  }

  const handleChangeAddressButtonClick = () => {
    setisChangeAddressVisible(true)
  }

  const handleChangeAddress = () => {
    setHandlingAddress({ name: address.name, street: address.street, houseNum: address.houseNum, localNum: address.localNum, zipCode: address.zipCode, city: address.city, email: address.email, phone: address.phone })
    setisChangeAddressVisible(false)
  }

  const handleDeleteLogoFunc = async () => {
    const res = await handleDeleteLogo()
    if (res) {
      setDeleteLogoTrigger(true)
    }
  }

  const { previewUrl, isDragging, getRootProps, getInputProps } = useLogoUploader({ defaultIconUrl: initialLogoUrl, setDeleteLogoTrigger: setDeleteLogoTrigger })

  const popover = <Popover id="popover-basic">
    <Popover.Body className="text-center">
      <span className='primary-accent-color-text'>.png .jpg .jpeg max 10MB</span>
    </Popover.Body>
  </Popover>

  return (
    <div className='row justify-content-center'>
      <div className="col-7">
        <div className='justify-content-center mt-2'>
          <div>
            <Modal size='lg' show={isChangeAddressVisible} onHide={handleCancelButtonClick} centered>
              <Modal.Header closeButton>
                <Modal.Title>Zmień dane</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <InputAddressPanel address={handlingAddress} handleEditAddress={handleEditAddress} handleChangeAddress={handleChangeAddress} title={t("report_change")} />
              </Modal.Body>
            </Modal>
            <div className='panel-header-title'>Dane kontrahenta</div>
            <div className='col-auto ms-1'>
              {address.name} <br />
              {address.street} {address.houseNum} {address.localNum.trim() ? '/' + address.localNum : ''}<br />
              {address.zipCode} {address.city} <br />
              {address.nip ? 'NIP: ' + address.nip : address.tax ? 'NIP: ' + address.tax : ''}<br />
              {address.email.trim() ? 'E-mail: ' + address.email : ''}<br />
              {address.phone.trim() ? t("phone") + ': ' + address.phone : ''}
            </div>
            {/* <button className='btn-app-secondary mt-4' onClick={handleChangeAddressButtonClick}>
              Zgłoś zmianę
            </button> */}
          </div>
        </div>
      </div>
      <div className="col-5 d-flex align-items-center">
        {isLoadingLogo ? (<LoadingSpinner />)
          :
          (<div className='d-flex flex-column'>
            <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
              <div
                {...getRootProps()}
                className='my-account-logotype dotted-container element-pointer'
              >
                <input {...getInputProps()} />
                <img
                  src={deleteLogoTrigger ? '' : previewUrl}
                  alt='logotyp'
                  style={{ maxWidth: '80px', maxHeight: '80px', objectFit: 'contain' }}
                  onError={(e) => {
                    e.target.src = '/Icons/uploadImg.svg'
                  }}
                />
                <span className='app-link'>Wgraj logotyp</span>
              </div>
            </OverlayTrigger>
            <button className='mt-2 btn-app-secondary' onClick={handleDeleteLogoFunc}>Usuń logotyp</button>
          </div>)
        }
      </div>
    </div>
  )
}

export default CustomerDataCard